<form [formGroup]="paymentToClinicalTrialRNDForm">
  <div class="main-box">
    <div class="d-flex p-2 float-end sticky-button">
      <button (click)="exportList()" type="button" class="btn btn-primary-datalist ms-3">
        <i class="fa-solid fa-download"></i>
        <span class="hidebuttonName"> EXPORT</span>
      </button>
    </div>
    <app-loader [count]="10" [appearance]="'line'" [isLoading]="isLoading">
      <div class="claim-table">
        <div class="table-container">
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th class="equal-width-col">{{labelConstants.Details}}</th>
                  <th class="equal-width-col">{{labelConstants.Cost}}</th>
                  <th *ngFor="let item of projectList" class="equal-width-col">
                    {{ item.projectName }}
                  </th>
                  <th class="equal-width-col">{{labelConstants.Total}}</th>
                </tr>
              </thead>
              <tbody>
                <ng-container formArrayName="paymentToClinicalTrial">
                  <tr *ngFor="
                        let item of paymentToClinicalTrial.controls;
                        let i = index
                      " [formGroupName]="i">
                    <td class="equal-width-col">
                      <span>{{ item.get("participantName")?.value }}</span>
                    </td>
                    <td class="equal-width-col">
                      <span>{{ item.get("totalGross")?.value }}</span>
                    </td>
                    <ng-container formArrayName="projects">
                      <td class="equal-width-col" *ngFor="
                            let itemDetails of getProjectDetails(i).controls;
                            let j = index
                          " [formGroupName]="j">
                        <span>{{ itemDetails.get("rndEligibility")?.value | customPercentage:
                          env.CurrencyFormat}}</span>
                      </td>
                    </ng-container>
                    <td>
                      <span>{{
                        item.get("totalEligibilityPer")?.value
                        }}</span>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
              <tfoot
                *ngIf="paymentToClinicalTrial.controls && paymentToClinicalTrial.controls.length > 0; else noRecords">
                <tr>
                  <td class="equal-width-col" colspan="1"><b>{{labelConstants.PaymentsToClinicalTrialTotal}} (£)</b></td>
                  <td class="equal-width-col">
                    <span><b>{{ getCostTotal() }}</b></span>
                  </td>
                  <td class="equal-width-col" *ngFor="let item of projectList; let projectIndex = index">
                    <span><b>{{ getTotalProduct(projectIndex) }}</b></span>
                  </td>
                  <td>
                    <span><b>{{ getTotalQualifyingCosts() }}</b></span>
                  </td>
                </tr>
              </tfoot>
              <ng-template #noRecords>
                <tfoot>
                  <tr>
                    <td [colSpan]="3+projectList.length" class="text-center">{{commonLabelConstants.NoReacordFound}}
                    </td>
                  </tr>
                </tfoot>
              </ng-template>
            </table>
          </div>
        </div>
      </div>
    </app-loader>
  </div>
</form>
